import { AccountFormContext } from "@shared/features/common/AccountForm.context";
import { QuickConnectContext } from "@shared/features/onboarding/QuickConnect.context";
import { QUICK_CONNECT_EXCHANGES } from "@shared/common/constants";
import { ConnectExchangeTabs } from "@shared/features/portfolio/types";
import { useContext, useEffect } from "react";
import { ClientData } from "@shared/types";
import { ExternalConnectAccountContext } from "@shared/features/configuration/ExternalConnectAccount.context";

interface useConnectExchangeProps {
  primaryExchange?: string;
  account?: ClientData;
}

const useConnectExchange = ({
  primaryExchange,
  account,
}: useConnectExchangeProps) => {
  const { tab, setTab, isDemoWorkspace } = useContext(AccountFormContext)!;
  const { closeDrawer, onBackToSelectExchange } =
    useContext(QuickConnectContext) || {};
  const { isExternalConnectAccount } =
    useContext(ExternalConnectAccountContext) || {};

  const isQuickConnectExchange =
    !!primaryExchange && QUICK_CONNECT_EXCHANGES.has(primaryExchange);
  const showTabs =
    !isDemoWorkspace &&
    isQuickConnectExchange &&
    !account &&
    !isExternalConnectAccount;

  useEffect(() => {
    if (showTabs) {
      setTab(ConnectExchangeTabs.QUICK_CONNECT);
    } else {
      setTab(undefined);
    }
  }, [showTabs]);

  return {
    showTabs,
    setTab,
    tab,
    onBackToSelectExchange,
    closeDrawer,
  };
};

export default useConnectExchange;
